// removed by extract-text-webpack-plugin
module.exports = {"flexContainer":"App__flexContainer___1QMH_"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.css
// module id = 1007
// module chunks = 0